import * as React from "react";
import { Avatar, Tooltip } from "antd";
import { TaskViewVisualStore } from "../stores";
import TasksGridVisualStore from "../stores/TasksGridVisualStore";
import { PrincipalInfo } from "../types";
import TaskUserProfilePicture from "./TaskUserProfilePicture";

type Props = {
    actor?: PrincipalInfo | null;
    legacyUserId?: string | null;
    legacyUserName?: string | null;
    store: TaskViewVisualStore | TasksGridVisualStore;
    size?: number | "small" | "large" | "default";
    className?: string;
    style?: React.CSSProperties;
    showName?: boolean;
};

const ActorBadge: React.FC<Props> = ({
    actor,
    legacyUserId,
    legacyUserName,
    store,
    size = 24,
    className,
    style,
    showName = true,
}) => {
    const resolvedUserName = store.getUserDisplayName(
        actor?.id || legacyUserId,
        legacyUserName || actor?.displayName,
    );
    const displayName =
        actor?.type === "User" || !actor
            ? resolvedUserName || "Unknown actor"
            : actor?.displayName ||
              legacyUserName ||
              legacyUserId ||
              "Unknown actor";
    const inactiveLabel = actor?.isInactive ? " (Inactive)" : "";
    const tooltip = actor?.source
        ? `${displayName} - ${actor.source}`
        : displayName;

    if (!actor || actor.type === "User") {
        return (
            <span>
                <TaskUserProfilePicture
                    store={store}
                    userId={actor?.id || legacyUserId || null}
                    userName={displayName}
                    className={className}
                    size={size}
                    style={style}
                    tooltipMsg={tooltip}
                />
                {showName && (
                    <span style={{ verticalAlign: "middle", marginLeft: 10 }}>
                        {displayName}
                        <span style={{ color: "red" }}>{inactiveLabel}</span>
                    </span>
                )}
            </span>
        );
    }

    const label =
        actor.type === "ApiKey" ? "K" : actor.type === "System" ? "S" : "?";

    return (
        <Tooltip title={tooltip}>
            <span>
                <Avatar className={className} size={size} style={style}>
                    {label}
                </Avatar>
                {showName && (
                    <span style={{ verticalAlign: "middle", marginLeft: 10 }}>
                        {displayName}
                        <span style={{ color: "red" }}>{inactiveLabel}</span>
                    </span>
                )}
            </span>
        </Tooltip>
    );
};

export default ActorBadge;
